(function () {
  function initCarousels() {
    // Initialize all carousels on the page
    document.querySelectorAll("[data-carousel]").forEach((carousel) => {
      // Skip if already initialized
      if (carousel.dataset.initialized === "true") return;

      const slides = carousel.querySelectorAll(".carousel-slide");
      const counter = carousel.querySelector(".carousel-current");
      const prevBtn = carousel.querySelector("[data-carousel-prev]");
      const nextBtn = carousel.querySelector("[data-carousel-next]");

      if (slides.length <= 1) return;

      let currentIndex = 0;
      let touchStartX = 0;
      let touchEndX = 0;

      function showSlide(index) {
        if (index < 0) index = slides.length - 1;
        if (index >= slides.length) index = 0;

        slides.forEach((slide) => slide.classList.remove("active"));
        slides[index].classList.add("active");
        currentIndex = index;

        if (counter) counter.textContent = currentIndex + 1;
      }

      function nextSlide() {
        showSlide(currentIndex + 1);
      }

      function prevSlide() {
        showSlide(currentIndex - 1);
      }

      // Click navigation
      if (prevBtn) prevBtn.addEventListener("click", prevSlide);
      if (nextBtn) nextBtn.addEventListener("click", nextSlide);

      // Touch/swipe navigation
      carousel.addEventListener(
        "touchstart",
        (e) => {
          touchStartX = e.changedTouches[0].screenX;
        },
        { passive: true }
      );

      carousel.addEventListener(
        "touchend",
        (e) => {
          touchEndX = e.changedTouches[0].screenX;
          const diff = touchStartX - touchEndX;

          if (Math.abs(diff) > 50) {
            if (diff > 0) {
              nextSlide();
            } else {
              prevSlide();
            }
          }
        },
        { passive: true }
      );

      carousel.dataset.initialized = "true";
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initCarousels);
  } else {
    initCarousels();
  }
})();
